<template>
  <div class="take-pictures">
  <div v-for="(item,listIndex) in list" :key='listIndex' class="content">
    <div class="photo-content">
      <div v-if="item && item.staticSmallImg || (item.staticSmallList && item.staticSmallList.length > 0)" class="img-item static">
        <template v-if="item && item.staticSmallImg">
          <van-image width="100%" lazy-load :src="item.staticSmallImg" @click="showViewImage(item.staticBigImg)">
            <span class="tip">Schematic</span>
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
            <!--加载失败-->
            <template v-slot:error>加载失败</template>
          </van-image>
        </template>
        <!-- <template v-if ="item && item.staticSmallList && (item.staticSmallList.length) > 0">
          <div v-for="(value,index) in item.staticSmallList" :key="index">
            <van-image width="100%" lazy-load :src="value" @click="showViewImage(item.swipeBigList[index])">
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
            <template v-slot:error>加载失败</template>
          </van-image>
          </div>
        </template> -->
      </div>
      <div class="img-item" :class="{'add-photo':item.rejectId == 7 || item.rejectId == 12 || item.rejectId == 9}">
        <!-- 上传组件，预备一套原生的方案 -->
        <template v-if="!$isOpenInWebview">
          <h5-upload :id="item.fileId" :keyValue="item.key" :maxCount="item.maxCount?item.maxCount:1"
            :staticSmallImg_mutiOneCase="item.staticSmallImg_mutiOneCase"
            :staticBigImg_mutiOneCase="item.staticBigImg_mutiOneCase"
            @delete="deleteImg"
            @afterRead="afterRead">
          </h5-upload>
        </template>
        <template v-if="$isOpenInWebview">
          <native-upload
            v-if="item.maxCount &&item.maxCount ===1"
            :id="item.fileId"
            :loading="loading"
            :staticImg="item.staticImg?item.staticImg:''"
            :key-value="item.key"
            :maxCount="item.maxCount"
            :preImg="item.preImg?item.preImg:''"
            :status = item.status
            :sourceType="item.sourceType"
            @delete="deleteImg"
            @takePhoto="takePhoto">
          </native-upload>
        </template>
        <!-- <div v-if="isFirst&&(!item.preImg)" class="wrapper" @click="showTipModal()"></div> -->
      </div>
    </div>
  </div>
  <van-image-preview v-model="show" :images="images"></van-image-preview>
  <!-- 提示弹框 -->
  <!-- <photo-overlay :show="showTip" @comfirm="confirmTip"></photo-overlay> -->

  </div>
</template>

<script>
const h5Upload = () => import('./photo/h5Upload.vue');
const nativeUpload = () => import('./photo/nativeUpload.vue');

export default {
  name:'takePictures',
  components:{
    h5Upload,
    nativeUpload
  },
  props: {
    list: {
      type: Array,
      default: ()=>[]
    },
    isFirst: {
      type:Boolean,
      default: false
    },
    loading:{
      type:Boolean,
      default: true
    },
    url:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      images:null,
      show: false
      // showTip:false,
    }
  },
  methods:{
    afterRead(params) {
      this.$emit('afterRead',params)
    },
    deleteImg(params){
      this.$emit('delete',params)
    },
    takePhoto(params,status=0){
      const {key, photoIndex,delKey, sourceType} = params
      this.$emit('takePhoto',{key,photoIndex,status,delKey, sourceType})
    },
    // 预览图片
    showViewImage(img){
      this.show = true
      this.images = Array.isArray(img) ? img : [img]
    },
    // 拍照提示框
    // showTipModal(){
    //   if(this.isFirst){
    //     this.showTip = true
    //   }
    // },
    // 确认提示
    // confirmTip(){
    //   this.showTip = false
    //   this.$emit("update:isFirst",false)
    // },
    // 删除图片
    closeImg(index,listIndex){
      // 删除图片
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  // margin: 0 13px 0;
  // .title-desc {
  //   font-size: 13px;
  //   font-weight: 400;
  //   color: #333;
  //   width: 100%;
  //   text-align: justify;
  //   .title-title {
  //     display: inline;
  //   }
  //   .details-desc {
  //     display: inline;
  //     color: #999;
  //   }
  // }
  .photo-content {
    // margin: 20px 10px 20px;
    display: flex;
    justify-content: space-between;
    // flex-wrap: wrap;
    .img-item {
      width: 316px;
      height: auto;
      & /deep/.swiper-img {
        margin-top: 0;
        .van-swipe-item {
          height: 150px;
        }
      }
      .wrapper {
        transform: translateZ(0);
        width: 100%;
        height: 150px;
        top: 0;
        margin-top: -150px;
      }
      .close {
        position: absolute;
        top: 5px;
        right: 5px;
        z-index: 1;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #666;
        font-size: 12px;
        line-height: 24px;
        text-align: center;
        color: #fff;
      }
    }
    .add-photo{
      width:100%;
    }
    .static{
      width: 316px;
      min-height: 316px;
      border-radius: 16px;
      overflow: hidden;
      & /deep/ .van-image {
        position: relative;
        display:block;
        margin-bottom: 5px;
        img {
          width: 158px;
          height: 158px;
          display: block;
        }
        .tip {
          // width: 65px;
          font-size: 12px;
          // height: 16px;
          text-align: center;
          line-height: 16px;
          color: #fff;
          background: rgba(51, 51, 51, 0.6);
          border-radius: 8px 0 8px 0;
          padding: 2px 8px;
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
        }
        // &:before {
        //   content: 'Schematic';
        //   position: absolute;
        //   left: 0;
        //   top: 0;
        //   right: 65px;
        //   width: 65px;
        //   font-size: 12px;
        //   height: 16px;
        //   text-align: center;
        //   line-height: 32px;
        //   color: #fff;
        //   background: rgba(51, 51, 51, 0.6);
        //   z-index: 1;
        // }
      }
    }
  }
  /deep/ .van-image:before {
    width: 100% !important;
  }
}
</style>
